<template>
  <component :is="comp" />
</template>

<script>
import { isMobile } from '@/utils/common.js'
import layoutPc from './components/pc'
import layoutH5 from './components/h5'
export default {
  name: 'Layout',
  components: {
    layoutPc,
    layoutH5
  },
  data() {
    return {}
  },
  computed: {
    comp() {
      if (isMobile()) {
        // 移动端
        return 'layoutH5'
      }
      return 'layoutPc'
    }
  },
  methods: {},
  mounted() { }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  .main-container {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue